module.exports = __webpack_public_path__ + "media/images/search-4a10c71d289d91e961b98cf0fc100aa8.svg";